import { Button, Hidden, Stack, Typography } from '@mui/material';
import React from 'react';
import i18n from '@utils/i18n';
import RowLayout from '@components/RowLayout';
import Link from '@components/LocalizedLink';

const QuickActions = () => {
  const t = i18n.getFixedT(null, null, '');

  return (
    <RowLayout
      sx={{
        maxWidth: 'auto',
        minHeight: { md: '300px', xs: '208px' },
        backgroundColor: { xs: '#F6F6F6' },
        alignItems: 'center',
        justifyContent: 'center',
        px: { lg: '320px' },
        py: { md: '97px', xs: '60px' }
      }}
    >
      <Stack
        sx={{
          width: { lg: '100%', md: '75%', xs: '100%' },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',

          px: { xs: 2.5, sm: 5, md: 0 },
          gap: { xs: 2.5 }
        }}
        data-aos="fade-up"
        data-aos-offset="0"
        data-aos-delay="100"
        data-aos-duration="300"
        data-aos-once="true"
      >
        {' '}
        <Stack
          textAlign={{ md: 'center', xs: 'center' }}
          sx={{ gap: 5, flexGrow: 1 }}
        >
          <Hidden mdDown>
            <Typography
              fontWeight={700}
              fontFamily="Pretendard"
              sx={{
                color: { xs: '#000' },
                fontSize: {
                  md: 48,
                  xs: '30px'
                },
                lineHeight: '100%',
                letterSpacing: { xs: '-1.5px', md: '-2.4px' },
                whiteSpace: { xs: 'pre-line', md: 'nowrap' }
              }}
            >
              {t('pages.flagshop.career.title')}
            </Typography>
          </Hidden>
          <Hidden mdUp>
            <Typography
              fontWeight={700}
              fontFamily="Pretendard"
              sx={{
                color: { xs: '#000' },
                fontSize: {
                  xs: '30px'
                },
                lineHeight: '130%',
                letterSpacing: { xs: '-1.5px', md: '-2.4px' },
                whiteSpace: { xs: 'pre-line', sm: 'nowrap' }
              }}
            >
              {t('pages.flagshop.career.title-mobile')}
            </Typography>
          </Hidden>

          <Typography
            fontWeight={500}
            fontFamily="Pretendard"
            sx={{
              color: { xs: '#000' },
              fontSize: {
                md: 18,
                xs: '18px'
              },
              letterSpacing: { xs: '-0.9px', md: '-0.9px' },
              whiteSpace: { xs: 'pre-line', sm: 'nowrap' }
            }}
          >
            {t('pages.flagshop.career.subtitle')}
          </Typography>
        </Stack>
        <Stack
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: { sm: 'center', xs: 'flex-start' },
            gap: { md: 1.5, xs: 1 }
          }}
        >
          <Button
            sx={{
              borderRadius: 0,
              backgroundColor: { xs: '#335AFF' },
              color: { xs: '#FFFFFF' },
              fontSize: { md: 18, xs: 18 },
              fontWeight: 500,
              ':hover': {
                backgroundColor: { md: '#2D4FDE', xs: '#335AFF' },
                color: { xs: '#FFFFFF' }
              },
              height: { xs: 48 },
              gap: 0.5,
              letterSpacing: { xs: '-0.9px', md: '-0.9px' },
              width: { xs: '100%', md: 'auto' },
              minWidth: { md: '240px', sm: '335px' },
              maxWidth: { sm: 'fit-content', xs: '100%' },
              p: 0
            }}
          >
            <Link
              href="/career"
              sx={{
                width: '100%',
                height: '100%',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',

                boxShadow: 'none',
                color: 'inherit'
              }}
            >
              {' '}
              {t('button.view-job-postings')}
            </Link>
          </Button>
        </Stack>
      </Stack>
    </RowLayout>
  );
};

export default QuickActions;
